import { Winston } from 'winston';

type LogFunction = (message: string) => void;

export function installUnhandledPromiseRejectionHandler(logger: Winston | LogFunction, exitOnFailure: boolean) {
  const logFunction = (typeof logger === 'function') ? logger : logger.error;

  process.on('unhandledRejection', (reason: any, _) => {
    logFunction(`Unhandled Promise Rejection ${reason?.stack || reason}`);
    if (exitOnFailure) {
      process.exit(1);
    }
  });
}
